import { FormattedMessage } from 'react-intl';
import { TbIllustration } from 'components/Figma';

export function NoOpportunityError() {
  return (
    <div className="w-full h-full flex items-center justify-center gap-10">
      <TbIllustration name="Congratulations" size="sm" />
      <div>
        <p className="text-base font-bold">
          <FormattedMessage id="common.congratulations" defaultMessage="Congratulations" />!
        </p>
        <p className="text-base">
          <FormattedMessage
            id="benchmark.common.error.no-opportunity"
            defaultMessage="You're ahead of the competition, and we didn't find any immediate growth opportunities."
          />
        </p>
      </div>
    </div>
  );
}
